"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdAccountTestResponseToJSON = exports.AdAccountTestResponseFromJSONTyped = exports.AdAccountTestResponseFromJSON = exports.instanceOfAdAccountTestResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the AdAccountTestResponse interface.
 */
function instanceOfAdAccountTestResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdAccountTestResponse = instanceOfAdAccountTestResponse;
function AdAccountTestResponseFromJSON(json) {
    return AdAccountTestResponseFromJSONTyped(json, false);
}
exports.AdAccountTestResponseFromJSON = AdAccountTestResponseFromJSON;
function AdAccountTestResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
    };
}
exports.AdAccountTestResponseFromJSONTyped = AdAccountTestResponseFromJSONTyped;
function AdAccountTestResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
    };
}
exports.AdAccountTestResponseToJSON = AdAccountTestResponseToJSON;
